import useStyles from "isomorphic-style-loader/useStyles";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useStore } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { fetchTicketDetailByOrderId, fetchTicketDetailByTicketId, fetchTicketDetailByUrlCode, fetchTicketImageSend, fetchTicketQuestionTypeChange, fetchTicketRateSend, fetchTicketSend, V } from "../../../../../api";
import { action_fetch_order_detail, action_fetch_ticket_question_type } from "../../../../../store/actions/pages/customer";
import Header from "../../../../components/header";
import { useApp, useQuery } from "../../../../hooks/common";
import { ChatBox } from "./components/chat-box";
import { ChatInputBox } from "./components/chat-input";
import { SubmitQuestionMask } from "./components/submit-question-mask";
import { TicketOrder } from "./components/ticket-order";
import { TypeSelect } from "./components/type-select";
import classes from './style.module.scss';
import Compressor from 'compressorjs'
import ReturnOrderEditor from "../../../me/pages/order/detail/components/return-order";

const MessageBox = props => {
    useStyles(classes)
    const { showMsg, showMsgTxt } = props

    return (<React.Fragment>
        {
            showMsg &&
            <div className={classes.MessageBox}>
                {showMsgTxt}
            </div>
        }
    </React.Fragment>
    )
}

/*
1. /me/m/faq/support-ticket/TK00000001 || /user/faq/support-ticket/TK00000001 用tkid
2. /me/m/faq/support-ticket?id=89382104 用orderid不弹窗
3. /me/m/faq/support-ticket?code=fGH0ZM-g6JoOwAsAl0uV6g 用code 邮件链接里来
4. /me/m/faq/support-ticket?orderid=89382104 用orderid
*/
/**
 * 1. 用户发的文字和图片都没有questionTypeCode和questionType
 * 2. 有questionTypeCode和reasonCode或message（reasonCode和message可能同时存在也可能只存在其中之一）一定是弹窗
 * 3. 只有questionTypeCode且没有message或者reasonCode是切换主题的记录，不需要同步到erp
 */

const TicketDetail = props => {
    useStyles(classes)
    const Intl = useIntl()
    const history = useHistory()
    const location = useLocation()
    const isApp = useApp()
    const store = useStore()
    const params1 = useParams()
    const query1 = useQuery()
    const pageCustomer = useSelector(state => state.pageCustomer)
    const { ticketQuestionType } = pageCustomer

    const [questionMaskShow, setQuestionMaskShow] = useState(false)
    const [ticket, setTicket] = useState(null);
    const [order, setOrder] = useState(null);
    const [customerName, setCustomerName] = useState(null);
    const [headSculptureUrl, setHeadSculptureUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [subject, setSubject] = useState(0);
    const [message, setMessage] = useState('');
    const [messageInvalid, setMessageInvalid] = useState(false);
    const [showTip, setShowTip] = useState(false);
    const [showMsg, setShowMsg] = useState(false);
    const [showMsgTxt, setShowMsgTxt] = useState('');
    const [questionTypeList, setQuestionTypeList] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [questionsReason, setQuestionsReason] = useState([]);
    const [questionSubmitLoading, setQuestionSubmitLoading] = useState(false);
    const [descriptionRequired, setDescriptionRequired] = useState(false);
    const [rateShow, setRateShow] = useState(false);
    const [rateTxt, setRateTxt] = useState('');
    const [rateType, setRateType] = useState('5');
    const [userLastRate, setUserLastRate] = useState('');
    const [questionObject, setQuestionObject] = useState({ // 信息收集弹窗的数据obj
        questionTypeInput: '',
        showSelectItem: false,
        descriptionInput: '',
        uploadImgList: [],
        uploadImgFileList: []
    });
    const pageParams = useRef();
    const bodyScrollTop = useRef();
    const apiLoading = useRef(false);
    const maskUpload = useRef(); // 弹窗上传图片ref
    const chatDiv = useRef();
    const lastChatDiv = useRef();

    const submitSelectBorder = useRef();
    const reasonInputOthersBorder = useRef();
    const descriptionBorder = useRef();

    const [showReturnOrderEditor, setShowReturnOrderEditor] = useState(false)
    const [returnItems, setReturnItems] = useState([])

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        // document.body.style.background = "#f6f6f6"
        if (window.zE) {
            window.zE('webWidget', 'hide');
        }
        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (!ticketQuestionType) {
                await TicketDetail.fetchData(store, null, null)
            }
        }
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        // 从ticket列表跳转过来 用history接受传值的参数
        let params = location?.state;
        let id = params?.id;
        // 接受url传值的参数 兼容类似/me/m/faq/support-ticket/:id的链接 app用
        let urlParams = params1?.ticketId
        // 不弹窗的传参
        let urlParamsNoMask = query1?.id
        // 其他页面传orderid过来
        let urlParamsOrderId = query1?.orderid
        // 客服邮件跳转过来携带code 可能会存在code=*******&isApp=1....的情况
        let customerCode = query1?.code

        // 如果链接中没有传值 而且本地没有数据 则会跳转到ticket列表
        if (!id && !localStorage.__order && !urlParams && !urlParamsNoMask && !customerCode && !urlParamsOrderId) {
            alert("Order does not exist")
            history.go(-1)
        }
        // app消息通知带ticketid跳转 或者链接里拼TK id
        if ((urlParams && isApp) || (urlParams && urlParams?.indexOf("TK") != -1)) {
            id = urlParams
            urlParams = null
        }
        pageParams.current = { params, id, urlParams, urlParamsNoMask, urlParamsOrderId, customerCode }
    }, [])

    useEffect(() => {
        // 初始化问题列表 && pageParams.current
        if (Array.isArray(ticketQuestionType) && ticketQuestionType?.length > 0 ) {
            let qTList = ticketQuestionType?.map(l => { return { ...l, selected: false } })
            let qTReasonList = []
            setQuestionTypeList(ticketQuestionType)
            setQuestions(qTList)
            setQuestionsReason(qTReasonList)
            switchFunc()
        }
    }, [ticketQuestionType])

    const switchFunc = (noRefresh) => {
        if (pageParams.current?.urlParamsNoMask) {
            getMsgById(pageParams.current.urlParamsNoMask, noRefresh)
        } else if (pageParams.current?.urlParams) {
            getMsgByLinkId(pageParams.current.urlParams, noRefresh)
        } else if (pageParams.current?.id) {
            localStorage.removeItem("__order")
            getMsgByUrlId(pageParams.current.id, noRefresh)
        } else if (pageParams.current?.customerCode) {
            getMsgByCode(pageParams.current.customerCode, noRefresh)
        } else if (pageParams.current?.urlParamsOrderId) {
            getMsgById(pageParams.current.urlParamsOrderId)
        } else if (localStorage.getItem("__order")) {
            getMsgByLocalData(noRefresh)
        } else {
            setLoading(false)
            setOrder({})
        }
    }

    const changeQuestionTypeList = (order, callback, noRefresh) => {
        let qTList, qTReasonList
        if(!noRefresh){
            console.log("subject: ",subject)
            const showReturn = order?.logistics?.packages?.find(p => p?.status == 3)
            if(!showReturn){
                qTList = [...(ticketQuestionType || [])]?.filter(q => q?.value != '04')
                                                        ?.map(q => {
                                                            if(q.value == subject){
                                                                return {...q, selected: true}
                                                            }
                                                            return {...q, selected: false}
                                                        })
                qTReasonList = qTList?.find(q => q.value == subject)?.reasons || []
                setQuestionTypeList(qTList)
                setQuestions(qTList)
                setQuestionsReason(qTReasonList)
            } else {
                qTList = ticketQuestionType?.map(l => {
                                    if(l.value == subject){
                                        return {...l, selected: true}
                                    }
                                    return { ...l, selected: false }
                        })
                qTReasonList = qTList?.find(q => q.value == subject)?.reasons || []
                setQuestionTypeList(ticketQuestionType)
                setQuestions(qTList)
                setQuestionsReason(qTReasonList)
            }
        }
        callback && callback?.(qTList)
    }

    const getMsgByLocalData = async (noRefresh) => {
        const id = JSON.parse(localStorage.getItem("__order"))?.id
        const res = await fetchTicketDetailByOrderId(id)
        if (res?.code == 200) {
            const { ticket, order, cusomerName, headSculptureUrl } = res?.result
            let subject = ticket?.questionTypeCode || 0
            subject = checkData(subject, ticket, order)

            setTicket({ ...ticket })
            setOrder({ ...order })
            changeQuestionTypeList(order, (qTList) => {
                let questionsNew = qTList?.map(q => {
                    if (q.value == subject) {
                        q.selected = true
                    } else {
                        q.selected = false;
                    }
                    return q
                })
                setCustomerName(cusomerName)
                setHeadSculptureUrl(headSculptureUrl)
                setLoading(false)
                setSubject(subject)
                setQuestions(questionsNew)
                initScroll()
                // if(subject == '04'){
                //     openReturnMask(order)
                // }
            }, noRefresh)
        } else {
            getDataFailFunc()
        }

    }

    const getMsgByCode = async (id, noRefresh) => {
        //客服code
        const res = await fetchTicketDetailByUrlCode(id)
        if (res?.code == 200 && res?.result) {
            const { ticket, order, cusomerName, headSculptureUrl } = res.result
            let subject = ticket?.questionTypeCode || 0
            subject = checkData(subject, ticket, order)

            setTicket({ ...ticket })
            setOrder({ ...order })
            changeQuestionTypeList(order, (qTList) => {
                let questionsNew = qTList?.map(q => {
                    if (q.value == subject) {
                        q.selected = true
                    } else {
                        q.selected = false;
                    }
                    return q
                })
                setCustomerName(cusomerName)
                setHeadSculptureUrl(headSculptureUrl)
                setLoading(false)
                setSubject(subject)
                setQuestions(questionsNew)
                initScroll()
                // if(subject == '04'){
                //     openReturnMask(order)
                // }
            }, noRefresh)
        } else {
            getDataFailFunc()
        }
    }

    const getMsgByLinkId = async (id, noRefresh) => {
        // 获取链接里的/id
        const res = await fetchTicketDetailByOrderId(id);
        if (res?.code == 200 && res?.result) {
            const { ticket, order, cusomerName, headSculptureUrl } = res.result
            if (ticket?.ticketReplies?.length > 0) {
                if (ticket.ticketReplies.slice(0)[ticket.ticketReplies.slice(0).length - 1]['sender'] == "buyers") {
                    setShowTip(true)
                } else {
                    setShowTip(false)
                }
            }
            setTicket({ ...ticket })
            setOrder({ ...order })
            changeQuestionTypeList(order, (qTList) => {
                const returnQT = qTList?.find(q => q?.value == '04')
                setCustomerName(cusomerName)
                setHeadSculptureUrl(headSculptureUrl)
                setLoading(false)
                // setSubject('04')
                initScroll()
                if(returnQT){
                    typeSelectChange({ value: '04', label: Intl.formatMessage({ id: 'return_the_oder' }) })
                }
            }, noRefresh)
        } else {
            getDataFailFunc(res)
        }
    }

    const getMsgById = async (id, noRefresh) => {
        // 获取链接里的?id=
        const res = await fetchTicketDetailByOrderId(id);
        if (res?.code == 200 && res?.result) {
            const { ticket, order, cusomerName, headSculptureUrl } = res.result
            let subject = ticket?.questionTypeCode || 0
            subject = checkData(subject, ticket, order)
            setTicket({ ...ticket })
            setOrder({ ...order })
            changeQuestionTypeList(order, (qTList) => {
                setCustomerName(cusomerName)
                setHeadSculptureUrl(headSculptureUrl)
                setLoading(false)
                setSubject(subject)
                initScroll()
                // if(subject == '04'){
                //     openReturnMask(order)
                // }
            }, noRefresh)
        } else {
            getDataFailFunc(res)
        }
    }

    const getMsgByUrlId = async (id, noRefresh) => {
        const res = await fetchTicketDetailByTicketId(id);
        if (res?.code == 200 && res?.result) {
            const { ticket, order, cusomerName, headSculptureUrl } = res?.result
            let subject = ticket?.questionTypeCode || 0
            subject = checkData(subject, ticket, order)

            setTicket({ ...ticket })
            setOrder({ ...order })
            changeQuestionTypeList(order, (qTList) => {
                let questionsNew = qTList?.map(q => {
                    if (q.value == subject) {
                        q.selected = true
                    } else {
                        q.selected = false;
                    }
                    return q
                })
                setCustomerName(cusomerName)
                setHeadSculptureUrl(headSculptureUrl)
                setLoading(false)
                setSubject(subject)
                setQuestions(questionsNew)
                initScroll()
                // if(subject == '04'){
                //     openReturnMask(order)
                // }
            }, noRefresh)
        } else {
            getDataFailFunc(res)
        }
    }

    const getDataFailFunc = (res) => {
        console.log('Order does not exist, result: ', res)
        if (res?.code === 401) {
            history.push(`/user`)
        } else {
            history.goBack()
        }
    }

    const checkData = (subject, ticket, order) => {
        let subjectReturn = subject
        let operaId = order?.id || ticket?.operaId || ''
        if(!operaId){
            return subjectReturn
        }
        if (subject && (!ticket?.subject || ticket?.subject == 'undefined' || !ticket?.subject?.match(/[a-z]/g))) {
            questionTypeChangeApi({
                operaId: operaId,
                questionTypeCode: subject,
                questionType: questions?.find(q => q?.value == subject)?.label || ''
            })
        } else if (!subject && ticket?.subject && (ticket?.subject === '7' || ticket?.subject == '000')) {
            let otherObject = questionTypeList[questionTypeList?.length - 1]?.value
            subjectReturn = otherObject
            questionTypeChangeApi({
                operaId: operaId,
                questionTypeCode: subject,
                questionType: questions?.find(q => q?.value == subject)?.label || ''
            })
        }
        if (ticket?.ticketReplies?.length > 0) {
            if (ticket?.ticketReplies[ticket?.ticketReplies.length - 1]?.sender == 'buyers') {
                setShowTip(true)
            } else {
                setShowTip(false)
            }
        }
        return subjectReturn
    }

    const questionTypeChangeApi = async (obj) => {
        const request = await fetchTicketQuestionTypeChange(obj)
        return request
    }

    const typeSelectChange = async (e) => {
        let operaId = order?.id || ticket?.operaId || ''
        if(!operaId){
            alert(Intl.formatMessage({id: 'please_select_order_first', defaultMessage:'Please select an order first!'}))
            return false
        }
        const res = await questionTypeChangeApi({
            operaId,
            questionTypeCode: e?.value,
            questionType: e?.label
        })
        if (res?.code == 200) {
            // 判断选择的是退货
            if(e?.value == '04'){
                openReturnMask(order)
                setSubject(e.value)
            } else {
                // 保证每个问题只展示一次
                let isShowed = ticket?.ticketReplies?.find(t => t.questionTypeCode == e.value && t.reasonCode && t.reason) || false
                let qTReasonList = questions?.find(q => q.value == e.value)?.reasons || []
                let isLastQuestion = questions[questions?.length - 1]?.value == e.value

                setSubject(e.value)
                if ((qTReasonList?.length > 0 || isLastQuestion) && !isShowed) {
                    // 判断description是否是必填
                    if (isLastQuestion) {
                        setDescriptionRequired(true)
                    } else {
                        setDescriptionRequired(false)
                    }
                    setQuestionMaskShow(true)
                    setQuestionsReason(qTReasonList)
                }
            }
            refreshTicket(true)
        } else if (res?.code == 300) {
            toLogin()
        }
        return true
    }

    const openReturnMask = (order) => {
        const showReturn = order?.logistics?.packages?.filter(p => p?.status == 3)
        const returnProducts = showReturn?.map(s => s.products)?.flat(Infinity)
        setReturnItems(returnProducts)
        if(returnProducts?.length > 0 ){
            setShowReturnOrderEditor(true)
        }
    }

    const groupReplies = (replies) => {
        var groups = _.groupBy(replies, function (obj) {
            return new Date(obj.date).toLocaleDateString() + " " + new Date(obj.date).toTimeString().substr(0, 5);
        })
        return groups
    }

    const addRate = () => {
        if (!subject) {
            alert(Intl.formatMessage({ id: "select_tip" }));
            return false
        }
        if (!rateShow) {
            setRateShow(true)
            // initScroll(150)
        } else {
            return
        }
        let ticketArg = ticket || {}
        let replies = []
        replies = (ticketArg?.ticketReplies || []).concat([])
        let rateHistory = (userLastRate || ticketArg?.ticketRateService || "")
        replies.push({
            sender: 'seller',
            message: '',
            imageUrls: [],
            date: new Date().getTime(),
            isRate: true,
            rateType: rateHistory?.rate + '' || '5',
            rateTxt: rateHistory?.message || ''
        })
        ticketArg.ticketReplies = replies
        setTicket(ticketArg)
        //   this.initScroll()
    }

    const rateConfirm = async (rateTxt, rateType) => {
        if (apiLoading.current) return
        apiLoading.current = true
        let txt = rateTxt;
        let type = Number(rateType) || 5;
        let params = {
            id: ticket?.id || '',
            message: txt,
            rate: type,
        }
        const res = await fetchTicketRateSend(params)
        if (res?.code == 200) {
            let ticketArg = ticket || {}
            let ticketLength = ticket?.ticketReplies?.length
            if (ticketLength > 0 && ticket?.ticketReplies?.[ticketLength - 1]?.isRate) {
                ticket.ticketReplies.pop()
            }
            setRateShow(false)
            setTicket(ticketArg)
            setUserLastRate({
                rate: type,
                message: txt
            })
        } else {
            setRateShow(false)
        }
        apiLoading.current = false
        refreshTicket(true)
    }

    const rateTextAreaChange = (e) => {
        let ticketArg = ticket || {}
        let replies = []
        replies = (ticketArg?.ticketReplies || []).concat([])
        replies[replies?.length - 1] = {
            ...replies[replies.length - 1],
            rateTxt: e,
        }
        ticketArg.ticketReplies = replies
        setTicket(ticketArg)
        setRateTxt(e)
    }

    const rateTypeChange = (e) => {
        let ticketArg = ticket || {}
        let replies = []
        replies = (ticketArg?.ticketReplies || []).concat([])
        replies[replies?.length - 1] = {
            ...replies[replies.length - 1],
            rateType: e,
        }
        ticketArg.ticketReplies = replies
        setTicket(ticketArg)
        setRateType(e)
    }

    const textareaChange = (evt) => {
        if (!subject) {
            alert(Intl.formatMessage({ id: "select_tip" }));
            return
        } else {
            setMessage(evt?.currentTarget?.value)
            setMessageInvalid(false)
        }
    }

    const handleImage = async (evt) => {
        evt.preventDefault()
        if (!subject) {
            alert(Intl.formatMessage({ id: "select_tip" }));
            return false
        }
        if (!validate(true)) {
            return false
        }
        if(apiLoading.current){
            return
        }
        apiLoading.current = true
        let operaId = order?.id || ticket?.operaId || ''
        if (operaId) {
            const files = evt.currentTarget.files
            let type = files?.[0]?.type
            if (type.indexOf('gif') != -1) {
                const formData = new FormData()
                formData.append("operaId", operaId)
                formData.append("message", '-')
                formData.append('imageFiles', files?.[0])
                const res = await fetchTicketImageSend(formData)
                apiLoading.current = false
                if (res?.code == 200) {
                    afterSend(files[0])
                }
            } else {
                const file = await compressorImage(files[0], 'blob')
                const formData = new FormData()
                formData.append("operaId", operaId)
                formData.append("message", '-')
                formData.append('imageFiles', file)
                const res = await fetchTicketImageSend(formData)
                apiLoading.current = false
                if (res?.code == 200) {
                    afterSend(files[0])
                }
            }
        } else {
            console.log('This ticket is not exist!')
        }
    }

    const afterSend = (file, message) => {
        let ticketArg = ticket || {}
        let replies = (ticketArg?.ticketReplies || []).concat([])
        if (file) {
            const src = window.navigator.userAgent.indexOf('Chrome') >= 1 || window.navigator.userAgent.indexOf('Safari') >= 1 ? window.webkitURL.createObjectURL(file) : window.URL.createObjectURL(file)
            replies.push({
                sender: 'buyers',
                message: '-',
                imageUrls: [src],
                date: new Date().getTime()
            })
        } else if (message) {
            replies.push({
                sender: 'buyers',
                message: message,
                date: new Date().getTime()
            })
        }
        ticketArg.ticketReplies = replies
        if (ticketArg) {
            if (ticketArg.ticketReplies.slice(0)[ticketArg.ticketReplies.slice(0).length - 1]['sender'] == "buyers") {
                setShowTip(true)
            } else {
                setShowTip(false)
            }
        }
        setTicket({ ...ticketArg })
        initScroll()
        refreshTicket(true)
    }

    const handleTicket = async (evt) => {
        if (!subject) {
            alert(Intl.formatMessage({ id: "select_tip" }));
            return false
        }
        if (!validate()) {
            return false
        }
        if(apiLoading.current){
            return
        }
        apiLoading.current = true
        let operaId = order?.id || ticket?.operaId || ''
        if (operaId) {
            let params = {
                operaId,
                message: message
            }
            const res = await fetchTicketSend(params)
            apiLoading.current = false
            if (res?.code == 200) {
                afterSend('', message)
                setMessage('')
            } else if (res?.code == 300) {
                toLogin()
            }
        } else {
            console.log('This ticket is not exist!')
        }
    }

    const refreshTicket = (noRefresh) => {
        if(!ticket.id){
            setLoading(true)
            switchFunc(noRefresh)
        }
    }

    const validate = (ignoreMessage) => {
        setMessageInvalid(!message || !ignoreMessage)
        return (order || ticket) && (message || ignoreMessage)
    }

    const toLogin = () => {
        if (isApp) {
            window.location.href = "chic-me://chic.me/loginRoot"
        } else {
            // window.location.href = `/i/login?redirectUrl=`+ window.location.pathname + (window.location.search||'')
            history.push(`/i/login?redirectUrl=${encodeURIComponent(window.location.href)}`)
        }
    }

    const initScroll = (offset = 150) => {
        setTimeout(() => {
            if(chatDiv.current){
                chatDiv.current.scrollTop = chatDiv.current?.scrollHeight? chatDiv.current?.scrollHeight - offset : 0
            }
        }, 10)
    }

    const bottomPx = (px) => `${2 * px / 75 * 1}rem`;

    const clearTicketData = () => {
        hideNoInputTips()
        let copyList = [...questionsReason];
        copyList.forEach(c => c.isSelected = false);
        setQuestionMaskShow(false)
        setQuestionObject({
            questionTypeList: [],
            questionTypeInput: '',
            showSelectItem: false,
            descriptionInput: '',
            uploadImgList: [],
            uploadImgFileList: [],
        })
        setDescriptionRequired(false)
        setQuestionSubmitLoading(false)
        setQuestionsReason(copyList)
    }

    const hideNoInputTips = () => {
        if(submitSelectBorder.current){
            submitSelectBorder.current.style.border = 'none'
        }
        if(reasonInputOthersBorder.current){
            reasonInputOthersBorder.current.style.border = 'none'
        }
        if(descriptionRequired && descriptionBorder.current){
            descriptionBorder.current.style.border = 'none'
        }
    }

    const questionReasonChange = (item) => {
        let copyList = [...questionsReason];
        let lastItem = [...questionsReason].pop();
        let selectItem = copyList.find(e => e.value == item.value);
        copyList.forEach(item => {
            item.isSelected = false;
        })
        selectItem.isSelected = true;
        if (selectItem.value == lastItem.value) {
            setDescriptionRequired(true)
            setQuestionsReason(copyList)
        } else {
            setDescriptionRequired(false)
            setQuestionObject({
                ...questionObject,
                questionTypeInput: '',
                showSelectItem: false
            })
            setQuestionsReason(copyList)
        }
    }

    const questionSubmit = async () => {
        if (apiLoading.current) return;
        apiLoading.current = true
        let params = {};
        // 选了什么问题
        params.question = subject;
        // 选择的原因（有的问题没有）
        params.selectReason = questionsReason.find(i => i.isSelected == true);
        // 原因描述 仅限Others
        if (params.selectReason && params.selectReason.value == questionsReason[questionsReason.length - 1].value) {
            params.selectReasonInput = questionObject.questionTypeInput
        }
        // 描述
        params.descriptionInput = questionObject.descriptionInput

        if (!checkParams(params)) return
        // 上传的图片
        let imgFileList = questionObject?.uploadImgFileList?.map(img => {
            if (img.type.indexOf('gif') != -1) {
                return img
            } else {
                // return new HtmlImageCompress(img, { quality: 0.7, imageType: img.type })
                return compressorImage(img)
            }
        })
        let operaId = order?.id || ticket?.operaId || ''
        if (operaId) {
            Promise.all(imgFileList).then(results => {
                // console.log(results)
                const formData = new FormData()
                formData.append('operaId', operaId)
                formData.append('questionTypeCode', subject)
                formData.append('questionType', questions.find(q => q.value == subject)?.label)
                formData.append('reasonCode', params?.selectReason?.value || '100')
                // 如果原因选择了others 那么reason传others输入的值
                formData.append('reason', params?.selectReasonInput || params?.selectReason?.label || 'Others')
                formData.append('message', questionObject.descriptionInput)
                results.forEach(item => {
                    const { file } = item
                    if (file) {
                        formData.append('imageFiles', file)
                    } else {
                        formData.append('imageFiles', item)
                    }
                })

                fetchTicketImageSend(formData).then(res => {
                    if (res?.code == 200) {
                        let ticketArg = ticket || {}
                        let replies = (ticketArg?.ticketReplies || []).concat([])

                        replies.push({
                            sender: 'buyers',
                            message: questionObject.descriptionInput,
                            date: new Date().getTime(),
                            imageUrls: questionObject.uploadImgList,
                            questionTypeCode: subject,
                            questionType: questions.find(q => q.value == subject).label,
                            reasonCode: params?.selectReason?.value || '100',
                            reason: params?.selectReasonInput || params?.selectReason?.label || 'Others'
                        })
                        ticketArg.ticketReplies = replies
                        if (ticketArg) {
                            if (ticketArg.ticketReplies.slice(0)[ticketArg.ticketReplies.slice(0).length - 1]['sender'] == "buyers") {
                                setShowTip(true)
                            } else {
                                setShowTip(false)
                            }
                        }
                        setTicket(ticketArg)
                        setShowMsg(true)
                        setMessage('')
                        setShowMsgTxt(Intl.formatMessage({ id: 'submit_successfully' }))
                        apiLoading.current = false
                        clearTicketData();
                        setTimeout(() => {
                            setShowMsg(false)
                            setShowMsgTxt('')
                        }, 2000)
                        initScroll()
                    }
                })

            })
        } else {
            console.log('This ticket is not exist!')
        }
    }

    const checkParams = (params) => {
        if (questionsReason.length > 0 && !params.selectReason) {
            submitSelectBorder.current.style.border = '1px solid red'
            submitSelectBorder.current?.scrollIntoView()
            apiLoading.current = false
            return false
        } else {
            hideNoInputTips()
        }
        if (params.selectReason && params.selectReason.value == questionsReason[questionsReason.length - 1].value && !params.selectReasonInput) {
            reasonInputOthersBorder.current.style.border = '1px solid red'
            reasonInputOthersBorder.current?.scrollIntoView()
            apiLoading.current = false
            return false
        } else {
            hideNoInputTips()
        }
        if (!params.descriptionInput && descriptionRequired) {
            descriptionBorder.current.style.border = '1px solid red'
            descriptionBorder.current?.scrollIntoView()
            apiLoading.current = false
            return false
        } else {
            hideNoInputTips()
        }
        return true
    }

    const deleteImg = (index) => {
        let fileList = [...questionObject.uploadImgFileList];
        let imgList = [...questionObject.uploadImgList];
        fileList.splice(index, 1);
        imgList.splice(index, 1);
        setQuestionObject({
            ...questionObject,
            uploadImgFileList: fileList,
            uploadImgList: imgList
        })
        clearFile()
    }

    const clearFile = (e) => {
        if(maskUpload.current){
            maskUpload.current.value = null
        }
    }

    const questionImgUpload = (e) => {
        if (!e.target.files || e.target.files.length == 0) {
            return
        }
        let file = [...e.target.files]
        // 判断是否有重复项
        file.forEach((files, index) => {
            let sameFile = questionObject.uploadImgFileList.find(f => f.name === files.name);
            if (sameFile) {
                file.splice(index, 1)
            }
        })
        if (file.length == 0) {
            return
        }
        let fileList = [...questionObject.uploadImgFileList].concat(file)
        let imgSrcList = [];
        if (fileList.length > 3) {
            fileList = fileList.splice(0, 3);
        }

        fileList.forEach(item => {
            var src = typeof item == 'string' ?
                item :
                window.navigator.userAgent.indexOf("Chrome") >= 1 ||
                    window.navigator.userAgent.indexOf("Safari") >= 1 ?
                    window.webkitURL.createObjectURL(item) :
                    window.URL.createObjectURL(item);
            imgSrcList.push(src);
        })
        setQuestionObject({
            ...questionObject,
            uploadImgFileList: fileList,
            uploadImgList: imgSrcList
        })
        e.target.value = ''
    }

    const compressorImage = (image, backType, quality) => {
        return new Promise((resolve, reject) => {
            new Compressor(image, {
                quality: quality || 0.6,
                success(result){
                    const file = new File([result], image?.name, {type: image?.type});
                    if(!backType || backType == 'blob'){
                        resolve(result)
                    } else if (backType == 'file'){
                        resolve(file)
                    } else {
                        resolve(file)
                    }
                },
                error(err){
                    reject(err)
                }
            })
        })
    }

    return (
        <div className={classes.TicketDetail}>
            <Header centerSlot={Intl.formatMessage({ id: "ticket", defaultMessage: "Ticket" })} />

            <TicketOrder intl={Intl} history={history} order={order} ticket={ticket} />

            <TypeSelect intl={Intl} questions={questions} selectChange={typeSelectChange} subject={subject} type={"chat"}/>

            <ChatBox
                intl={Intl}
                history={history}
                ticket={{ ...ticket }}
                groupReplies={groupReplies}
                headSculptureUrl={headSculptureUrl}
                rateShow={rateShow}
                showTip={showTip}
                addRate={addRate}
                rateConfirm={rateConfirm}
                rateTextAreaChange={rateTextAreaChange}
                rateTypeChange={rateTypeChange}
                questionTypeList={questionTypeList}
                chatDiv={chatDiv}
                order={order}
                isApp={isApp}
            />

            <MessageBox showMsg={showMsg} showMsgTxt={showMsgTxt} />

            <ChatInputBox
                intl={Intl}
                messageInvalid={messageInvalid}
                textareaChange={textareaChange}
                message={message}
                handleImage={handleImage}
                handleTicket={handleTicket}
                isApp={isApp} />

            <SubmitQuestionMask
                intl={Intl}
                show={questionMaskShow}
                clearTicketData={clearTicketData}
                questionsReason={questionsReason}
                questionObject={questionObject}
                setQuestionObject={setQuestionObject}
                questionReasonChange={questionReasonChange}
                questionSubmit={questionSubmit}
                descriptionRequired={descriptionRequired}
                deleteImg={deleteImg}
                questionImgUpload={questionImgUpload}
                bodyScrollTop={bodyScrollTop?.current}
                bottomPx={bottomPx}
                maskUpload={maskUpload}
                submitSelectBorder={submitSelectBorder}
                reasonInputOthersBorder={reasonInputOthersBorder}
                descriptionBorder={descriptionBorder}
            />

            <ReturnOrderEditor
                show={showReturnOrderEditor}
                // order?.logistics?.packages
                onClose={(flag)=>{
                    if(flag == 'refresh'){
                        switchFunc(questions)
                        setShowReturnOrderEditor(false)
                    } else if(flag == 'ticket'){
                        // 去订单详情
                        if(isApp){
                            window.location.href = `chic-me://chic.me/orderDetail?id=${order?.id}`
                            return
                        }
                        history.push(`/user/order/detail/${order?.id}`);
                    } else {
                        setShowReturnOrderEditor(false)
                    }
                }}
                onEditor={(data)=>console.log('data', data)}
                orderId={order?.id}
                orderPackages={order?.logistics?.packages}
            />

        </div>
    )
}

TicketDetail.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_ticket_question_type(headers))
}

export default TicketDetail